export default {
  apple_pay: [
    'paymentMethodNonce',
    'deviceData',
  ],
  pay_pal: [
    'payPalEmail',
    'paymentMethodNonce',
    'deviceData',
  ],
  paypal_complete: [
    'paymentMethodNonce',
    'deviceData',
  ],
  card: [
    'deviceData',
  ],
  maxp_apple_pay: [
    'paymentMethodNonce'
  ],
  google_pay: [
    'paymentMethodNonce'
  ]
};
